import $ from 'jquery';

$(() => {
    $('.js-overlay').hover( function(){
		$(this).toggleClass('active');
	})
});
